module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "popularize"
  }, [_c('img', {
    staticClass: "top-banner",
    attrs: {
      "src": (_vm.GET_STATIC_IMG_HOST + "popularize/others/banner4.jpg")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "separate-line"
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "separate-line"
  }), _vm._v(" "), _c('div', {
    staticClass: "teamwork-wrapper"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("- 专业的团队配置 -")]), _vm._v(" "), _c('div', {
    staticClass: "teamwork-list"
  }, [_c('div', {
    staticClass: "teamwork"
  }, [_c('img', {
    attrs: {
      "src": (_vm.GET_STATIC_IMG_HOST + "popularize/day4/afternoon.png")
    }
  }), _vm._v(" "), _c('p', [_vm._v("编辑团队：有条不紊的编辑团队，将一个个作品，进行精致打磨，并呈现给用户")])]), _vm._v(" "), _c('div', {
    staticClass: "teamwork"
  }, [_c('img', {
    attrs: {
      "src": (_vm.GET_STATIC_IMG_HOST + "popularize/day4/books.png")
    }
  }), _vm._v(" "), _c('p', [_vm._v("版权团队：高效的版权团队，小伙伴们致力于将业内最优质的作品签约至作品有声化平台，为内容规模与质量提供了强有力的保证")])]), _vm._v(" "), _c('div', {
    staticClass: "teamwork"
  }, [_c('img', {
    attrs: {
      "src": (_vm.GET_STATIC_IMG_HOST + "popularize/day4/morning.png")
    }
  }), _vm._v(" "), _c('p', [_vm._v("运营团队：喜马拉雅拥有完善的作品运营体系，将打磨后的作品精心挑选，量身定做包装形式，一一呈现给用户")])]), _vm._v(" "), _c('div', {
    staticClass: "teamwork"
  }, [_c('img', {
    attrs: {
      "src": (_vm.GET_STATIC_IMG_HOST + "popularize/day4/design.png")
    }
  }), _vm._v(" "), _c('p', [_vm._v("研发团队：高效迭代的研发团队，保证了作品有声化平台的完善运行")])])])]), _vm._v(" "), _c('div', {
    staticClass: "separate-line"
  }), _vm._v(" "), _c('div', {
    staticClass: "more-wrapper"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("- 了解更多 -")]), _vm._v(" "), _c('div', {
    staticClass: "links-wrapper"
  }, [_c('router-link', {
    staticClass: "link",
    attrs: {
      "to": {
        name: 'idols'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": (_vm.GET_STATIC_IMG_HOST + "popularize/others/大神云集@2x.png")
    }
  })]), _vm._v(" "), _c('router-link', {
    staticClass: "link",
    attrs: {
      "to": {
        name: 'workLib'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": (_vm.GET_STATIC_IMG_HOST + "popularize/others/海量作品@2x.png")
    }
  })]), _vm._v(" "), _c('router-link', {
    staticClass: "link",
    attrs: {
      "to": {
        name: 'classic'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": (_vm.GET_STATIC_IMG_HOST + "popularize/others/经典汇聚@2x.png")
    }
  })])], 1)]), _vm._v(" "), _c('router-link', {
    staticClass: "btn-join-bottom",
    attrs: {
      "to": {
        name: 'anchorIndex'
      }
    }
  }, [_vm._v("立即加入")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn-join-fixed",
    attrs: {
      "to": {
        name: 'anchorIndex'
      }
    }
  }, [_vm._v("立即加入")])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top-context"
  }, [_c('p', [_vm._v("作品有声化出版平台，6大福利扶持新人，致力为好声音们打造专属舞台")]), _vm._v(" "), _c('p', [_vm._v("生财致富靠播音，年入百万不是梦")]), _vm._v(" "), _c('p', [_vm._v("开放平台，收益看得见，随时可提现")]), _vm._v(" "), _c('p', [_vm._v("加入我们，这些福利将属于你")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "benefits-wrapper"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("- 你将拥有 -")]), _vm._v(" "), _c('div', {
    staticClass: "benefits"
  }, [_c('div', {
    staticClass: "benefit",
    staticStyle: {
      "padding-right": "0",
      "padding-bottom": "0"
    }
  }, [_c('div', {
    staticClass: "top",
    staticStyle: {
      "margin": "0"
    }
  }, [_c('i', {
    staticClass: "icon icon-50 icon-popularize-copyright"
  }), _vm._v(" "), _c('span', {
    staticClass: "sub-title"
  }, [_vm._v("版权保障")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "padding": "50px 37px 120px 0",
      "border-right": "1px solid #d9d9d9"
    }
  }, [_vm._v("喜马拉雅联手阅文集团、博集天卷、果麦文化、读客图书、电子工业出版社、清华大学出版社等多家图书行业领军企业，共同制造正版有声作品")])]), _vm._v(" "), _c('div', {
    staticClass: "benefit",
    staticStyle: {
      "padding-left": "37px"
    }
  }, [_c('div', {
    staticClass: "top"
  }, [_c('i', {
    staticClass: "icon icon-50 icon-popularize-earn"
  }), _vm._v(" "), _c('span', {
    staticClass: "sub-title"
  }, [_vm._v("丰厚收益")])]), _vm._v(" "), _c('p', [_vm._v("任务有保底、分成等多种收益，主播可长期享受有声作品的广告分成+打赏分成，每月结算，手机自助提现")])]), _vm._v(" "), _c('div', {
    staticClass: "benefit",
    staticStyle: {
      "border-right": "1px solid #d9d9d9"
    }
  }, [_c('div', {
    staticClass: "top"
  }, [_c('i', {
    staticClass: "icon icon-50 icon-popularize-data"
  }), _vm._v(" "), _c('span', {
    staticClass: "sub-title"
  }, [_vm._v("数据分析服务")])]), _vm._v(" "), _c('p', [_vm._v("通过认证的主播或机构即可接受任务邀请获得收益，并同时享受定时发布、数据分析、无限空间等多项特权服务，准确的数据分析，让主播更好的了解专辑收听情况，便于改善优化作品")])]), _vm._v(" "), _c('div', {
    staticClass: "benefit",
    staticStyle: {
      "padding-left": "37px"
    }
  }, [_c('div', {
    staticClass: "top"
  }, [_c('i', {
    staticClass: "icon icon-50 icon-popularize-broadcast"
  }), _vm._v(" "), _c('span', {
    staticClass: "sub-title"
  }, [_vm._v("优质的推广资源")])]), _vm._v(" "), _c('p', [_vm._v("喜马拉雅FM，拥有4亿海量用户，你的作品将在这里被万千声音爱好者熟知，并伴有优质资源位鼓励")])]), _vm._v(" "), _c('div', {
    staticClass: "benefit",
    staticStyle: {
      "border-bottom": "0",
      "border-right": "1px solid #d9d9d9"
    }
  }, [_c('div', {
    staticClass: "top"
  }, [_c('i', {
    staticClass: "icon icon-50 icon-popularize-identification"
  }), _vm._v(" "), _c('span', {
    staticClass: "sub-title"
  }, [_vm._v("官方认证")])]), _vm._v(" "), _c('p', [_vm._v("喜马拉雅官方认证后将通过网站、移动、无线等全渠道展示并推广您的有声作品，签约主播还可享受高端广告资源")])]), _vm._v(" "), _c('div', {
    staticClass: "benefit",
    staticStyle: {
      "border-bottom": "0",
      "padding-left": "37px"
    }
  }, [_c('div', {
    staticClass: "top"
  }, [_c('i', {
    staticClass: "icon icon-50 icon-popularize-chance"
  }), _vm._v(" "), _c('span', {
    staticClass: "sub-title"
  }, [_vm._v("海量机会")])]), _vm._v(" "), _c('p', [_vm._v("千万本实体书籍、网络书籍、绘本读物、报刊杂志都在等待您的精彩演播，周周都有新任务发布")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7ec00bfe!./~/vue-loader/lib/selector.js?type=template&index=0!./views/popularize/Benefits.vue
// module id = 1115
// module chunks = 0